import { render, staticRenderFns } from "./indexScgl.vue?vue&type=template&id=7bd7ca4a&scoped=true"
import script from "./indexScgl.vue?vue&type=script&lang=ts"
export * from "./indexScgl.vue?vue&type=script&lang=ts"
import style0 from "./indexScgl.vue?vue&type=style&index=0&id=7bd7ca4a&prod&lang=scss&scoped=true"
import style1 from "./indexScgl.vue?vue&type=style&index=1&id=7bd7ca4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd7ca4a",
  null
  
)

export default component.exports